import { registerDictionary } from '@/commons/popupRegister/dictionaryRegister.js';
import { registerCommonPopup } from '@/commons/popupRegister/commonPopupRegister.js';
export function register(app) {
  registerDictionary(app);
  registerCommonPopup(app);
}
